import AhoyEvent from 'shared/ahoy_event';

export default class GoogleOneTapTracker {
  static sendEvent(notification) {
    if (notification.isDisplayed()) {
      GoogleOneTapTracker.sendAhoyEvent('impression');
    } else if (notification.isSkippedMoment() && notification.getSkippedReason() == 'user_cancel') {
      GoogleOneTapTracker.sendAhoyEvent('close');
    }
  }

  static sendAhoyEvent(action) {
    let eventData = {
      action: action,
      feature: 'google one tap sign in'
    };
    AhoyEvent.send('VIDIO::FORM_POPUP', eventData);
  }
}
